// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b1223e0a","353":"41e3fc47","360":"6b911ec6","405":"13e9847e","407":"8600e855","514":"ab0c6211","645":"ef840b87","787":"11b35d64","850":"2322949b"}[chunkId] + ".chunk.js";
};